import createReactClass from 'create-react-class'
import React from 'react'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import ReactJson from 'react-json-view'
import ReportTablePanel from './report-table-panel'
import './report-panel.scss'

export default createReactClass({
  componentWillMount () {
    if (this.props.location.search) {
      let ggsId = this.props.location.search.substring(1)
      this.props.getCompanyReport(ggsId)
    }
  },
  backToSearchPage () {
    this.props.history.push('/search')
  },

  getErrorMessage (error) {
    return error.message ? error.message : (error.messages ? error.messages[0].text : '')
  },

  render () {
    return (
      <div className="container">
        <div className="report-view-panel">
          {this.props.isLoading
            ? <div className='loader-ctr'><span className="loading"></span></div>
            : <div>
              <Tabs>
                <TabList>
                  <button className='back-button' onClick={this.backToSearchPage}>
                    <span className='fa fa-caret-left'/>
                    Back
                  </button>
                  <Tab>Card View</Tab>
                  <Tab>Raw JSON</Tab>
                </TabList>
                <TabPanel>
                  {this.props.error
                    ? <div className="connect-error-alert">{this.getErrorMessage(this.props.error)}</div>
                    : <ReportTablePanel {...this.props} /> }
                </TabPanel>
                <TabPanel>
                  <div className='raw-json-view'>
                    <ReactJson src={this.props.error ? this.props.error : this.props.companyReport}/>
                  </div>
                </TabPanel>
              </Tabs>
            </div>
          }
        </div>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/report-panel.js